
import { ResultsDTO } from "Types";
import { BannerDTO } from "Interface";
import { ApiService } from "Services/ApiService";


export const BannerApiSlice = ApiService.injectEndpoints({
    endpoints: builder => ({
        getListOfBanners: builder.query<BannerDTO[], void>({
            query: () => ({
                url: `/banners`,
                method: "GET",
            }),
            transformResponse: (response: ResultsDTO<BannerDTO[]>) =>
                (response.results ?? []).filter(banner => banner.isActive !== "N"),
        }),
    }),
});

export const {
    useGetListOfBannersQuery
} = BannerApiSlice;
